import { Card } from "../components/Card";
import { saturday, sunday } from "../constants/schedule";

export default function Schedule() {
  return (
    <>
      <h1>Schedule</h1>
      <Card id="welcome1.5" className="welcome" bgc="fill" title="">
        <div>
          Take a look at the <a href="/media/pdfs/Conner_Family_Reunion_Letter_2025.pdf" target="connertab">most recent reunion letter</a> to get the latest details about the reunion!
        </div>
      </Card>

      <Card id="schedule" className="schedulesat" bgc="fill" title="Reunion Schedule - 2025">
        {/* <div name="schedule">(Tentative – exact times and activities subject to change!)</div> */}
        {/* <h2>Conner Reunion 2025 Schedule</h2> */}
        <ScheduleSaturday />
        <ScheduleSunday />
      </Card>
    </>
  );
};

function ScheduleSaturday() {
  // const cols = Object.keys(saturday[0]);
  // const numCols = cols.length;
 
  return (
    <>
      <h3>Saturday's Schedule</h3>
      <table className="schedule">
        <thead>
          <tr className="summary">
            <th className="schedulesummary" colSpan="3">
               Saturday, June 21 at Pomona Christian Church
            </th>
          </tr>
          <tr className="colhead">
            <th>Time</th>
            <th>Activity</th>
            <th>Location</th>
          </tr>
        </thead>
        <tbody>
          <TableRows src={saturday} />
        </tbody>
      </table>
    </>
  );
}

function ScheduleSunday() {
  return (
    <>
      <h3>Sunday's Schedule</h3>
      <table className="schedule">
        <thead>
          <tr className="summary">
            <th className="schedulesummary" colSpan="3">
              Sunday, June 22 at Hampton Inn, West Plains
            </th>
          </tr>
          <tr className="colhead">
            <th>Time</th>
            <th>Activity</th>
            <th>Location</th>
          </tr>
        </thead>
        <tbody>
          <TableRows src={sunday} />
        </tbody>
      </table>
    </>
  );
}

function TableRows({ src }) {
  return (
    <>
      {
        src.map((role, index) => (
          <tr key={index}>
            <td>{role.time}</td>
            <td>{role.activity}</td>
            <td>{role.location}</td>
          </tr>
        ))
      }
    </>
  );
}